// 典拠責任表示表記
export const TagAuthorityAuthorDisplay = 'W00001050001020001'

// 典拠責任表示カナ
export const TagAuthorityAuthorKana = 'W00001050001050001'

// 典拠出版者表記
export const TagAuthorityPublisherDisplay = 'SP0001050001020001'

// 典拠出版者カナ
export const TagAuthorityPublisherKana = 'SP0001050001050001'

// 典拠責件名表記
export const TagAuthoritySubjectDisplay = 'KM0001050001020001'

// 典拠件名カナ
export const TagAuthoritySubjectKana = 'KM0001050001050001'

// 典拠シリーズ表記
export const TagAuthoritySeriesDisplay = 'S00001050001020001'

// 典拠シリーズカナ
export const TagAuthoritySeriesKana = 'S00001050001050001'

// 典拠全集表記
export const TagAuthorityCompleteWorksDisplay = 'Z00001050001020001'

// 典拠全集カナ
export const TagAuthorityCompleteWorksKana = 'Z00001050001050001'
